import { SchedulerChatMessage, SchedulerScope } from './types';
import './messageGenerator.scss';

interface MessageGeneratorProps {
  canSchedule: boolean;
  enableCustomRuleInput: boolean;
  schedulerScope?: SchedulerScope;
}

export const generateChatMessages = ({
  canSchedule,
  enableCustomRuleInput,
  schedulerScope = 'day',
}: MessageGeneratorProps): SchedulerChatMessage[] => {
  const messages: SchedulerChatMessage[] = [];

  if (schedulerScope === 'week') {
    messages.push({
      id: 'plan-my-week-user',
      type: 'user',
      content: 'Plan my week',
    });
  }

  const welcomeContent =
    schedulerScope === 'week'
      ? `Let's schedule your week.\n\nI'll help you set up your preferences for **tasks and routines**.`
      : `Let's schedule your day. \n\nI'll help you set up your preferences for **sessions, tasks, and routines**.`;

  messages.push({
    id: 'welcome',
    type: 'ai',
    content: welcomeContent,
    cta: 'next',
  });

  if (!canSchedule) {
    return messages;
  }

  return messages;
};
